import { render, staticRenderFns } from "./GroupManage.vue?vue&type=template&id=a7cbdc98&scoped=true"
import script from "./GroupManage.vue?vue&type=script&lang=js"
export * from "./GroupManage.vue?vue&type=script&lang=js"
import style0 from "./GroupManage.vue?vue&type=style&index=0&id=a7cbdc98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7cbdc98",
  null
  
)

export default component.exports